import { Link } from "react-router-dom";

const CATEGORY_LINKS = [
  { to: "/category?type=movie", label: "电影" },
  { to: "/category?type=tv", label: "电视剧" },
  { to: "/category?region=国产", label: "国产剧集" },
  { to: "/category?region=欧美", label: "欧美影视" },
  { to: "/category?sort=rating", label: "高评分作品" },
];

const NEWS_LINKS = [
  { to: "/news", label: "影视新闻" },
  { to: "/news?category=review", label: "影视评论" },
  { to: "/news?category=industry", label: "行业报道" },
  { to: "/search?q=科幻", label: "科幻专题" },
  { to: "/search?q=悬疑", label: "悬疑专题" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-white text-xl" />
              </span>
              <span className="font-heading font-extrabold text-lg text-white">影视影院</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-300">
              影视影院致力于打造专业且便捷的影视内容查询平台，汇集电影、电视剧资料与最新影视资讯，帮助每一位观众快速选片、了解行业动态。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-background-200"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">影视分类</h4>
            <ul className="flex flex-col gap-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">影视资讯</h4>
            <ul className="flex flex-col gap-2.5">
              {NEWS_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">关于我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-accent-400" />
                </span>
                <span>contact@moviecinema.demo</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-accent-400" />
                </span>
                <span>400-000-0000（虚构演示）</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-accent-400" />
                </span>
                <span>示例大道 88 号 影视文化中心</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © 2025 影视影院 MovieCinema · 本站为纯前端演示站点，所有影视作品与资讯均为虚构演示数据
          </p>
          <p className="text-xs text-background-400 text-center sm:text-right">
            未接入真实播放、下载及数据接口，所有交互结果均为前端模拟
          </p>
        </div>
      </div>
    </footer>
  );
}